/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */

export type EnumAlboConfigurazioneTipoCampoDTOTipo =
  (typeof EnumAlboConfigurazioneTipoCampoDTOTipo)[keyof typeof EnumAlboConfigurazioneTipoCampoDTOTipo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumAlboConfigurazioneTipoCampoDTOTipo = {
  TEXT: 'TEXT',
  SELECT: 'SELECT',
  DATE: 'DATE',
  NUMBER: 'NUMBER',
} as const;
